import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  IconButton,
} from "@mui/material";
import { MyCloseIcon } from "../../Assets/svg/MyIcons";
import logo from "../../Assets/icon.png";
import moment from "moment";

const PaycentralTransactionInvoiceModal = ({ open, handleClose, transactionData }) => {
  if (!transactionData) return null;

  const {
    organizationName,
    oneTimeSetupFee,
    ongoingMaintenanceFee,
    newMerchantSetupFee,
    ongoingMaintenancePerMerchantFee,
    totalFee,
    status,
    createdAt,
  } = transactionData;

  const formatCurrency = (value) => {
    return value ? `USD ${parseFloat(value).toFixed(2)}` : "USD 0.00";
  };

  const formatDate = (date) => {
    if (!date) return "N/A";
    return moment(date).format("MMMM DD, YYYY");
  };

  const getStatusText = (status) => {
    const lower = (status || "").toLowerCase();
    if (lower === "success") return "Completed";
    if (lower === "pending") return "Pending";
    return "Unknown";
  };

  // const totalAmount =
  //   parseFloat(oneTimeSetupFee || 0) +
  //   parseFloat(ongoingMaintenanceFee || 0) +
  //   parseFloat(newMerchantSetupFee || 0) +
  //   parseFloat(ongoingMaintenancePerMerchantFee || 0);

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
      <DialogTitle>
        <div className="d-flex justify-content-between align-items-center">
          <Typography variant="h5">Billing Invoice</Typography>
          <IconButton onClick={handleClose}>
            <MyCloseIcon />
          </IconButton>
        </div>
      </DialogTitle>

      <DialogContent dividers className="invoice-modal__content">
        <div className="invoice-modal__scroll-wrapper">
          <div className="invoice-modal__invoice-card">
            <div className="invoice-modal__container">

              {/* HEADER */}
              <div className="invoice-modal__top-header">
                <div className="invoice-modal__header-left">
                  <img src={logo} alt="logo" className="invoice-modal__logo" />
                  <Typography className="invoice-modal__title">INVOICE</Typography>
                  <Typography className="invoice-modal__order-id">
                    {organizationName || "N/A"}
                  </Typography>
                </div>

                <div className="invoice-modal__header-right">
                  <Typography className="invoice-modal__company-name">
                    Billing Details
                  </Typography>
                  <div className="invoice-modal__company-info">
                    <Typography>Status: {getStatusText(status)}</Typography>
                    <Typography>Date: {formatDate(createdAt)}</Typography>
                  </div>
                </div>
              </div>

              {/* TABLE HEADER */}
              <div className="invoice-modal__items-section">
                <div className="invoice-modal__table-wrapper">

                  <div className="invoice-modal__table-header">
                    <div className="invoice-modal__table-header-row">
                      <div className="invoice-modal__col-description">
                        <Typography>Description</Typography>
                      </div>
                      <div className="invoice-modal__col-amount">
                        <Typography>Amount</Typography>
                      </div>
                    </div>
                  </div>

                  {/* TABLE BODY */}
                  <div className="invoice-modal__table-body">

                    {/* ROW */}
                    <div className="invoice-modal__table-row">
                      <div className="invoice-modal__col-description">
                        <Typography>One Time Setup Fee</Typography>
                      </div>
                      <div className="invoice-modal__col-amount">
                        <Typography>{(oneTimeSetupFee)}</Typography>
                      </div>
                    </div>

                    <div className="invoice-modal__table-row">
                      <div className="invoice-modal__col-description">
                        <Typography>Ongoing Maintenance Fee</Typography>
                      </div>
                      <div className="invoice-modal__col-amount">
                        <Typography>{(ongoingMaintenanceFee)}</Typography>
                      </div>
                    </div>

                    <div className="invoice-modal__table-row">
                      <div className="invoice-modal__col-description">
                        <Typography>New Merchant Setup Fee</Typography>
                      </div>
                      <div className="invoice-modal__col-amount">
                        <Typography>{(newMerchantSetupFee)}</Typography>
                      </div>
                    </div>

                    <div className="invoice-modal__table-row">
                      <div className="invoice-modal__col-description">
                        <Typography>Maintenance Per Merchant Fee</Typography>
                      </div>
                      <div className="invoice-modal__col-amount">
                        <Typography>
                          {(ongoingMaintenancePerMerchantFee)}
                        </Typography>
                      </div>
                    </div>

                  </div>
                </div>
              </div>

              {/* TOTAL SECTION */}
              <div className="invoice-modal__totals-wrapper">
                <div className="invoice-modal__totals">

                  <div className="invoice-modal__final-total-row">
                    <Typography className="invoice-modal__final-total-label">
                      Total Amount:
                    </Typography>
                    <Typography className="invoice-modal__final-total-value">
                      {(totalFee || oneTimeSetupFee + ongoingMaintenanceFee + newMerchantSetupFee + ongoingMaintenancePerMerchantFee)}
                    </Typography>
                  </div>

                </div>
              </div>

              {/* FOOTER */}
              <div className="invoice-modal__footer">
                <Typography className="invoice-modal__footer-title">
                  Thank you for your business!
                </Typography>
                <Typography className="invoice-modal__footer-note">
                  This is a system generated invoice.
                </Typography>
              </div>

            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default PaycentralTransactionInvoiceModal;